import { render } from "./ViewArticlePage.vue?vue&type=template&id=2defaf68"
import script from "./ViewArticlePage.vue?vue&type=script&lang=js"
export * from "./ViewArticlePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__